import { API_config } from '../config/apiConfig';

const apiUrl = API_config.apiUrl;
const authHeader = API_config.authHeader;

export async function updateDeviceModel(deviceId, model) {
  try {
    // Fetch existing device to retain required fields like uniqueId
    const existingResp = await fetch(`${apiUrl}/devices/${deviceId}`, {
      headers: {
        'Authorization': authHeader,
      },
    });
    if (!existingResp.ok) {
      throw new Error('Failed to fetch device');
    }
    const existing = await existingResp.json();

    // Prepare updated data. Clear CarStatus when model changes.
    const updatedData = { ...existing, model };
    
    if (updatedData.attributes) {
      // Create a shallow copy of attributes
      const newAttrs = { ...updatedData.attributes };
      
      // Explicitly remove ONLY the emergency flags
      delete newAttrs.CarStatus;
      delete newAttrs.sos;
      delete newAttrs.lastSmsTime;
      delete newAttrs.lastSmsBody;
      
      updatedData.attributes = newAttrs;
    }

    const response = await fetch(`${apiUrl}/devices/${deviceId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader,
      },
      body: JSON.stringify(updatedData),
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('updateDeviceModel: PUT failed', errorText);
      throw new Error(`Failed to update device model: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (err) {
    console.error('updateDeviceModel error', err);
    throw err;
  }
}
